import React, { useContext, useEffect, useState } from 'react'
import { Context } from './../../../context/app-context'
import {
  activitySEO,
  pointsByMatch,
  delayFlip,
  competitionId,
  timeForLevels,
} from './../../../constants/activity-constants'
import gameServices from './../../../services/game-service'

import sessionStorage from './../../../utils/userSessionStorage'
import useInterval from './../../../utils/useInterval'
import logoCampana from './../../../assets/images/logoCampana.png'

import GridCard from './../../molecules/grid-card/grid-card'
import logo from '../../../assets/images/logoCampana.png'
import background from '../../../assets/images/polygonGame.svg'

import Show from '../../../utils/show'

import './game.scss'

import getUserInfo from '../../../utils/getUserInfo'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import { interpolate } from 'gsap'
import { jsonToHash } from '../../../utils/crypto'
import { navigate } from 'gatsby'

const LOCALE =
  ['es-AR', 'es-CL', 'es-PE', 'es-PY', 'es-UY'].indexOf(process.env.LOCALE) > -1
    ? process.env.LOCALE
    : 'default'

const italatam = LOCALE === 'es-AR' || LOCALE === 'es-PY' || LOCALE === 'es-UY'

export default function Game() {
  const [session] = useState(new sessionStorage())
  const { dispatch, modalActive, tokenParticipation } = useContext(Context)
  const [level, setLevel] = useState(0)
  const [points, setPoints] = useState(0)
  const [totalPoints, setTotalPoints] = useState(0)
  const [time, setTime] = useState(timeForLevels[0])
  const [timerIsRunning, setTimerIsRunning] = useState(false)
  const [orderModalEducational, setOrderModalEducational] = useState([])
  const [initialized, setInitialized] = useState(false)

  const userInfo = getUserInfo()
  const gameLevel = async label => {
    const user_data =
      userInfo !== null
        ? await jsonToHash([
            {
              nombre: userInfo.name,
              apellido: userInfo.lastName,
              celular: userInfo.cellPhone,
              correo: userInfo.email,
              ciudad: userInfo.location.cityName,
              departamento: userInfo.location.countryStateName,
              pais: userInfo.countryName,
            },
          ])
        : null
    pushEventData({
      event: `Interacciones_juego_nivel` + level + `_Vmatch`,
      label,
      action: 'view',
      user_data,
      log_status: userInfo ? 'Yes' : 'Not',
    })
  }
  const handleClick = async label => {
    const user_data =
      userInfo !== null
        ? await jsonToHash([
            {
              nombre: userInfo.name,
              apellido: userInfo.lastName,
              celular: userInfo.cellPhone,
              correo: userInfo.email,
              ciudad: userInfo.location.cityName,
              departamento: userInfo.location.countryStateName,
              pais: userInfo.countryName,
            },
          ])
        : null
    pushEventData({
      event: 'Esroy preparada',
      label,
      action: 'click',
      user_data,
      log_status: userInfo ? 'Yes' : 'Not',
    })
  }

  const activeModalBienvenida = async label => {
    const user_data =
      userInfo !== null
        ? await jsonToHash([
            {
              nombre: userInfo.name,
              apellido: userInfo.lastName,
              celular: userInfo.cellPhone,
              correo: userInfo.email,
              ciudad: userInfo.location.cityName,
              departamento: userInfo.location.countryStateName,
              pais: userInfo.countryName,
            },
          ])
        : null
    pushEventData({
      event: `Interacciones_prejuego_VMatch`,
      label,
      action: 'view',
      user_data,
      log_status: userInfo ? 'Yes' : 'Not',
    })
  }
  const handleStart = () => {
    setLevel(1)
    setTimerIsRunning(true)
  }
  const handleEndgame = win => {
    setTimerIsRunning(false)
    dispatch({
      type: 'set-context',
      payload: {
        modalActive: {
          type: 'loading',
          handleClose: () => {
            // window.location.href = `${activitySEO.url}/`
          },
          props: { noClose: true },
        },
      },
    })

    // TODO: Redimir tokenParticipationService() => hanldedispatch modal pointsByMatch
    let payload = {
      point: totalPoints,
      tokenGame: tokenParticipation,
      gameId: competitionId,
    }
    var config = {
      headers: {
        Authorization: session.getToken().idToken,
      },
    }
    console.log(payload.gameId)
    gameServices
      .postGameParticipationSave(payload, config)
      .then(res => {
        if (res.status === 200) {
          dispatch({
            type: 'set-context',
            payload: {
              modalActive: {
                type: 'endGame',
                props: {
                  totalPoints,
                  win,
                  handleSuccess: () => {
                    handleRestart()
                  },
                },
                handleClose: () => {
                  // window.location.href = `${activitySEO.url}/`
                  navigate('/')
                },
              },
            },
          })
        } else {
          window.location.reload(false)
        }
      })
      .catch(e => {
        console.log(e)
        // window.location.href = `${activitySEO.url}/`
        navigate('/')
      })
  }

  const handleRestart = () => {
    window.location.reload(false)
  }

  useEffect(() => {
    let order = [0, 1, 2, 3, 4]
    order = order.sort(function () {
      return Math.random() - 0.5
    })
    setOrderModalEducational(order)
  }, [])

  // Cronometer
  useInterval(
    () => {
      setTime(time - 1)
    },
    timerIsRunning ? 1000 : null
  )

  useEffect(() => {
    if (time < 1) {
      handleEndgame(false)
    }
  }, [time])

  const restoreTimeForLevel = () => {
    if (level !== 5) {
      setTimerIsRunning(true)
      setTime(timeForLevels[level])
    }
  }

  const viewModalInfo = (__modalView, __handleClose) => {
    dispatch({
      type: 'set-context',
      payload: {
        modalActive: {
          type: 'educational',
          handleClose: () => {
            __handleClose()
            restoreTimeForLevel()
          },
          props: {
            modalView: __modalView,
            handleNext: () => {
              dispatch({
                type: 'set-context',
                payload: {
                  modalActive: null,
                },
              })
              __handleClose()
              restoreTimeForLevel()
            },
          },
        },
      },
    })
  }
  const isLogged = () => {
    return session.getToken() != null
  }
  useEffect(() => {
    if (session.getToken() !== null) {
      if (!tokenParticipation) {
        dispatch({
          type: 'set-context',
          payload: {
            modalActive: {
              type: 'redemption',
              handleClose: () => {
                //window.location.href = `${activitySEO.url}/`
                navigate('/')
              },
            },
          },
        })
      } else {
        dispatch({
          type: 'set-context',
          payload: {
            modalActive: null,
          },
        })
      }
    } else {
      dispatch({
        type: 'set-context',
        payload: {
          modalActive: {
            type: 'unauthenticated',
            handleClose: () => {
              //  window.location.href = `${activitySEO.url}/`
              navigate('/')
            },
          },
        },
      })
    }
  }, [session, dispatch, tokenParticipation])

  useEffect(() => {
    if (points !== 0) setTotalPoints(totalPoints + pointsByMatch)
    if (points >= pointsByMatch + pointsByMatch * level) {
      if (level <= 5) {
        setTimerIsRunning(false)
        let modalView = orderModalEducational[level - 1]
        gameLevel('Fin juego nivel ' + level)
        const nextLevel = () => {
          setLevel(level + 1)
          setPoints(0)
        }
        if (level !== 5) {
          setTimerIsRunning(false)
          setTimeout(() => {
            // delay 1 second until show modalview please
            viewModalInfo(modalView, nextLevel)
          }, 2000)
        }
        // setTimeout(() => {
        //   setLevel(level + 1)
        //   setPoints(0)
        // }, delayFlip)
      }
      // else {
      //   handleEndgame()
      // }
    }
  }, [points])
  useEffect(() => {
    if (totalPoints === 100) {
      viewModalInfo(orderModalEducational[level - 1], () => {
        handleEndgame(true)
      })
    }
  }, [totalPoints])
  useEffect(() => {
    gameLevel('Jugando nivel ' + level)
  }, [level])

  useEffect(() => {
    if (tokenParticipation) {
      activeModalBienvenida('Bienvenida a VMatch')
    }
  }, [tokenParticipation])

  // TODO: moment transform timer
  // const currentTime = moment(
  //   moment
  //     .duration({
  //       milliseconds: timer
  //     })
  //     .as("millisecond")
  // ).format("mm:ss")
  if (!isLogged()) {
    return (
      <div className="game">
        <div className="game__container"></div>
      </div>
    )
  }

  return (
    <div className="game">
      <div className="game__container">
        <section className="game__container__panel">
          <div className="panel-wrapper">
            {[
              // TODO: userMoment { label: "Tiempo", value: "1:00" },
              { label: 'TIEMPO', value: time },
              { label: 'PUNTOS', value: totalPoints },
              { label: 'NIVEL', value: level },
            ].map((item, index) => {
              return (
                <p className="panel-item" key={index}>
                  <span className="item-value">{item.value}</span>
                  <span className="item-label">{item.label}</span>
                </p>
              )
            })}
          </div>
        </section>
        <section className="game__container__body">
          {level < 1 && !modalActive && (
            <div className="popup">
              <div className="popup__wrapper">
                <h3 className="textBienvenida">Bienvenida a</h3>
                <img
                  className="logoCampana"
                  src={logoCampana}
                  alt="campana logo"
                />
                <p className="popup__wrapper__description">
                  <Show valid={!italatam}>
                    Demuestra que eres una experta <br /> memorizando y
                    encontrando todas <br />
                    las parejas del Mundo Nosotras. <br /> <br />{' '}
                    <span>¡Corre! Tienes poco tiempo.</span>
                  </Show>

                  <Show valid={italatam}>
                    Demostrá que sos una experta <br /> memorizando y
                    encontrando todas <br />
                    las parejas del Mundo Nosotras. <br /> <br />{' '}
                    <span>¡Corré! Tenés poco tiempo.</span>
                  </Show>
                </p>
                <button
                  className="btn-primary f-concentrate-game-btn butonHover"
                  onClick={() => {
                    handleStart()
                    handleClick('Estoy preparada')
                  }}
                >
                  Estoy preparada
                </button>
              </div>
            </div>
          )}
          <GridCard level={level} points={points} setPoints={setPoints} />

          <div className="game__container__logo-mob">
            <img src={logo} alt="V-Match" />
          </div>
        </section>
      </div>
    </div>
  )
}
